import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { verifyThisPAN } from "../../../redux/features/verifyPAN/verifyPAN";
import { GlobalConfiguration } from "../../../utils/configurationProvider";

export const usePanVerification = (pan) => {
  const dispatch = useDispatch();
  const prevPanRef = useRef(null);

  const { verifyPAN, verifyPANisLoading } = useSelector(
    (state) => state.verify,
  );

  useEffect(() => {
    if (!pan || pan?.length !== GlobalConfiguration?.panLength) {
      prevPanRef.current = null;
      return;
    }

    if (pan !== prevPanRef.current) {
      prevPanRef.current = pan;
      dispatch(verifyThisPAN({ pan_number: pan, showToast: false }));
    }
  }, [pan, dispatch]);

  return {
    verified: verifyPAN?.status ?? null,
    details: verifyPAN?.pan_details ?? null,
    loading: verifyPANisLoading,
    error: verifyPAN?.errors ?? null,
  };
};
